import { request } from '../utils/request';

export const getHubsWithCIOApi = search =>
  request.get('/analytics/cio/hubs', { params: { search } });
export const removeHubUsersDataCustomerIOApi = data =>
  request.put(`/analytics/remove-sync/${data.hubId}`, data);
